import { useIntl } from 'react-intl';
import { Col, Row } from 'antd';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import { ListNcmsQuery } from '@/core/domain/operational/Ncm/Ncm.types';
import { InputText } from '@/components/_common';
import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import ActiveExtraFilter from '@/components/_common/ExtraFilters/ActiveExtraFilter';

function NcmExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<ListNcmsQuery>) {
  const intl = useIntl();

  return (
    <Row gutter={[16, 16]}>
      <Col span={24} lg={8} md={10}>
        <InputText
          onlyNumber
          value={queryParams?.code}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, code: value }))
          }
          placeholder={intl.formatMessage({
            id: 'ncm.domain.code',
          })}
        />
      </Col>

      <Col span={24} lg={8} md={10}>
        <ActiveExtraFilter
          value={queryParams?.active}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              active: value as unknown as boolean,
            }))
          }
        />
      </Col>

      <Col span={24} lg={8} md={10}>
        <OrderExtraFilter
          value={queryParams?.order}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              order: value,
            }))
          }
        />
      </Col>
    </Row>
  );
}

export default NcmExtraFilters;
